export default {
      id: "i-alfa-logo-min-usage",
      viewBox: "0 0 19 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-alfa-logo-min",
      toString: function () {
        return this.url;
      }
    }